var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tableComponent,_vm._g(_vm._b({ref:"inner",tag:"component"},'component',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }